import type { Styles } from 'common/types';
import type { CSSProperties } from 'react';

export const styles: Styles = {
  archiveCard: {
    width: 120,
    height: 120,
    position: 'relative',
    borderRadius: '8px',
    overflow: 'hidden',
    cursor: 'pointer',
    border: '2px solid transparent',
    transition: 'all 0.2s',
    '&:hover': { opacity: 0.8 },
  },
  archiveCardSelected: {
    borderColor: 'primary.main',
    transform: 'scale(0.95)',
  },
  checkOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 118, 255, 0.2)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  archiveContainer: {
    backgroundColor: '#f8fafc',
    p: 3,
    borderRadius: 3,
    mb: 3,
    border: '1px solid',
    borderColor: 'divider',
  },
};

export const nativeStyles: Record<string, CSSProperties> = {
  imageElement: {
    objectFit: 'cover',
    objectPosition: 'center',
    height: '100%',
    width: '100%',
    borderRadius: 'inherit',
    display: 'block',
    pointerEvents: 'none',
  },
};
